var header_height = document.querySelector('.section-header').offsetHeight;
var bodyElement = document.querySelector('body');
bodyElement.style.paddingTop = header_height+'px';
window.addEventListener('scroll', function() {  
  if (window.scrollY > header_height) {
    bodyElement.classList.add('default-header');
  } else {
    bodyElement.classList.remove('default-header');
  }
});
var windowscroll = $(window).scrollTop();
if(windowscroll>header_height){
  bodyElement.classList.add('default-header'); 
}
document.querySelectorAll(".megatop ul li").forEach(function(megaCetegory){
  megaCetegory.addEventListener("mouseover", function(e){
    $(this).addClass('active').siblings().removeClass('active');
    var datahandle = $(this).data('handle');
    $(this).closest('.megamenu').find('.mega-category').removeClass('active');
    $(this).closest('.megamenu').find('.mega-cat-nav').removeClass('active');
    $('.mega-category[data-handle="'+datahandle+'"]').addClass('active');
    $('.mega-cat-nav[data-handle="'+datahandle+'"]').addClass('active');
  });
});
document.querySelectorAll('.header-search').forEach(function(searchButton) {
  searchButton.addEventListener('click',function(e){
    e.preventDefault();
    document.querySelector('body').classList.add('open-searchbox');
    document.querySelector('body').classList.add('default-header');
  });
});
document.querySelector('.search-close').addEventListener('click',function(e){
  e.preventDefault();
  document.querySelector('body').classList.remove('open-searchbox');
});
$('body').on('click',function(e){   
  var seachbox = $(".snippet-search-bar,#predictive-search,.header-search,.menu-icon,.menu-drawer");    
  if (!seachbox.is(e.target) && seachbox.has(e.target).length === 0){
    $('body').removeClass('open-searchbox menu-open');
  }
});
$(document).on('click','.nav-arrow',function(e){
  e.preventDefault();
  $(this).closest('.nav-wrap').next('.second-level').addClass('active');
  $('.menu-drawer').addClass('hidescroll');
});
$(document).on('click','.back-button-list',function(e){
  e.preventDefault();
  $(this).closest('.second-level').removeClass('active');
  var activelen = $('.second-level.active').length;
  if(activelen == 0){
    $('.menu-drawer').removeClass('hidescroll');
  }
});
$(document).on('click','.menu-icon',function(e){
  e.preventDefault();
  $('body').addClass('menu-open');
});
$(document).on('click','.menudrawer-close',function(e){
  e.preventDefault();
  $('body').removeClass('menu-open');
  $('.second-level').removeClass('active');
  $('.menu-drawer').removeClass('hidescroll');
});
$('.footer-mobile .ftr-title').on('click',function(e){
  $(this).next('ul').slideToggle();
  $(this).toggleClass('active');
});